import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getCopilotDraftGenerationPropertyUriForRequest, MESSAGE_PROPERTY_SET_ID, } from "owa-copilot-draft-generation-shared";
import extendedPropertyUri from "owa-service/lib/factory/extendedPropertyUri";
import type ExtendedPropertyUri from "owa-service/lib/contract/ExtendedPropertyUri";
import { IS_COPILOT_PROACTIVE_DRAFT_PROPERTY_NAME, PROACTIVE_DRAFT_GENERATION_PROPERTIES_NAME, } from "./constants";

export function getProactiveDraftSpecificExtendedPropertyUrisForRequest(): ExtendedPropertyUri[] {
    if (!isGlobalFeatureEnabled("mon-copilot-proactive-drafts-view") &&
        !isGlobalFeatureEnabled("mon-copilot-proactive-drafts-view-debug")) {
        return [];
    }
    return [
        extendedPropertyUri({
            PropertyName: IS_COPILOT_PROACTIVE_DRAFT_PROPERTY_NAME,
            PropertySetId: MESSAGE_PROPERTY_SET_ID,
            PropertyType: "Boolean",
        }),
        extendedPropertyUri({
            PropertyName: PROACTIVE_DRAFT_GENERATION_PROPERTIES_NAME,
            PropertySetId: MESSAGE_PROPERTY_SET_ID,
            PropertyType: "String",
        }),
    ];
}

export default function getProactiveDraftExtendedPropertyUrisForRequest(): ExtendedPropertyUri[] {
    const proactiveDraftProperties = getProactiveDraftSpecificExtendedPropertyUrisForRequest();
    return proactiveDraftProperties.length === 0
        ? []
        : [...proactiveDraftProperties, getCopilotDraftGenerationPropertyUriForRequest()];
}
